'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRACKER_MULTIPLE_START = exports.TRACKER_MULTIPLE_START = 'TRACKER_MULTIPLE_START';
var TRACKER_MULTIPLE_FINISH = exports.TRACKER_MULTIPLE_FINISH = 'TRACKER_MULTIPLE_FINISH';
var TRACKER_START = exports.TRACKER_START = 'TRACKER_START';
var TRACKER_SUCCESS = exports.TRACKER_SUCCESS = 'TRACKER_SUCCESS';
var TRACKER_ERROR = exports.TRACKER_ERROR = 'TRACKER_ERROR';
//# sourceMappingURL=types.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/redux/actions/types.js
 ** module id = 179
 ** module chunks = 1
 **/